import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCzS6s7mDh4B3HuFWa0dGNURuFeHEuS0fo",
    authDomain: "slop-ship-sdx-hack.firebaseapp.com",
    projectId: "slop-ship-sdx-hack",
    storageBucket: "slop-ship-sdx-hack.firebasestorage.app",
    messagingSenderId: "630332289694",
    appId: "1:630332289694:web:baf56e968f0948f675818f"
};

let app;
let auth;
let db;

try {
    // Check if all required config fields are present
    const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
    const missingFields = requiredFields.filter(field => !firebaseConfig[field]);
    
    if (missingFields.length > 0) {
        throw new Error(`Missing required Firebase configuration fields: ${missingFields.join(', ')}`);
    }

    // Initialize Firebase
    app = initializeApp(firebaseConfig);

    // Initialize Auth with error handling
    try {
        auth = getAuth(app);
        console.log('Firebase Auth initialized successfully');
    } catch (authError) {
        console.error('Error initializing Firebase Auth:', authError);
        throw authError;
    }

    // Initialize Firestore with error handling
    try {
        db = getFirestore(app);
        console.log('Firestore initialized successfully');
    } catch (dbError) {
        console.error('Error initializing Firestore:', dbError);
        throw dbError;
    }

} catch (error) {
    console.error('Firebase initialization failed:', error);
    throw new Error('Failed to initialize Firebase services. Please check your configuration.');
}

// Add connection state listener
if (db) {
    window.addEventListener('online', () => {
        console.log('Network connection restored - Firebase operations will resume');
    });

    window.addEventListener('offline', () => {
        console.warn('Network connection lost - Firebase operations may be affected');
    });
}

export { auth, db };